import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  chgUtiliserEspacesFilter,
  chgUtiliserMobilitesFilter,
  selectUtiliserFilters,
} from "../../../redux/ReduxFilter";
import { Container, Form } from "react-bootstrap";

const BlocChoixUtiliser = () => {
  const { t } = useTranslation();
  const _selectUtiliserFilters = useSelector(selectUtiliserFilters);
  const dispatch = useDispatch();

  return (
    <div className="sliderSticky">
      <div className="enteteBlocFiltre">
        <span>{t("public.filtres.filtre22")}</span>
      </div>
      <Container fluid className="mb-3 d-flex align-items-center flex-nowrap containerFiltres">
        <div className="m-1  align-items-center d-flex">
          <Form.Check
            className={_selectUtiliserFilters.espace ? "filtreActif" : "filtreNonActif"}
            type="checkbox"
            label={t("public.filtres.filtre17")}
            id="espace"
            name="espace"
            onChange={(e) => dispatch(chgUtiliserEspacesFilter(!_selectUtiliserFilters.espace))}
            checked={_selectUtiliserFilters.espace ? "checked" : ""}
          />
        </div>
        <div className="m-1 s align-items-center d-flex">
          <Form.Check
            className={_selectUtiliserFilters.mobilite ? "filtreActif" : "filtreNonActif"}
            type="checkbox"
            label={t("public.filtres.filtre20")}
            id="mobilite"
            name="mobilite"
            onChange={(e) => dispatch(chgUtiliserMobilitesFilter(!_selectUtiliserFilters.mobilite))}
            checked={_selectUtiliserFilters.mobilite ? "checked" : ""}
          />
        </div>
      </Container>
    </div>
  );
};

export default BlocChoixUtiliser;
